import React, { ComponentProps } from 'react'

import styled from '@emotion/styled'

import { Spacings } from '@surglogs-app/ui.theme'

import { getColorKeyFromColorVariant } from '../services/TypographyService'
import { ColorVariant } from '../services/VariantService'

import { Box } from './Box'

const StyledCircleLoader = styled(Box)<{
  variant: ColorVariant
  size: Spacings
}>`
  --size: ${({ theme, size }) => theme.ui.spacings[size]};
  width: var(--size);
  height: var(--size);
  border: calc(var(--size) / 8) solid
    ${({ theme, variant }) =>
      theme.ui.colors[getColorKeyFromColorVariant(variant)]};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

interface Props
  extends Omit<ComponentProps<typeof StyledCircleLoader>, 'variant' | 'size'> {
  variant?: ColorVariant
  size?: Spacings
}

export const CircleLoader = ({
  variant = 'default',
  size = 'md',
  ...rest
}: Props) => <StyledCircleLoader {...{ variant, size, ...rest }} />
